<style>
  main {
    /*background-color: #ddd;*/
    display: flex;
    flex-flow: column;
    /*flex: 1 1 auto;*/
    height: 100%;
    width: 100%;
  }
  .map {
    flex: 1 1 auto;
    /*cursor: pointer;*/
  }
  .settings {
    flex: 0 0 auto;
    display: flex;
    flex-flow: column;
    z-index: 1000;
    position: absolute;
    align-self: flex-end;
    width: 18em;
  }
  .layers {
    flex: 0 0 auto;
    display: flex;
    flex-flow: column;
    align-self: flex-end;
    background-color: #ffeb;
    border-radius: 0.2em;
    margin: 0.4em;
    width: 100%;
  }
  .date {
    flex: 0 0 auto;
    display: flex;
    flex-flow: row;
    align-self: flex-end;
    background-color: #ffeb;
    border-radius: 0.2em;
    margin: 0 0.4em 0.4em 0.4em; /* top | right | bottom | left */
    width: 100%;
  }
  .risk {
    flex: 0 0 auto;
    display: flex;
    flex-flow: row;
    align-self: flex-end;
    background-color: #ffeb;
    border-radius: 0.2em;
    margin: 0 0.4em 0.4em 0.4em; /* top | right | bottom | left */
    width: 100%;
  }
  .filler {
    flex: 1 1 auto;
  }
  .layer {
    flex: 0 0 auto;
    display: flex;
    flex-flow: row;
    margin: 0.2em 0.6em 0.4em 0.6em; /* top | right | bottom | left */
    align-self: left;
  }
  .legend {
    margin: 0; /* top | right | bottom | left */
    width: 0.8em;
    height: 0.8em;
    align-self: center;
    margin: 0 0.4em 0 0.4em; /* top | right | bottom | left */
  }
  .caption {
    flex: 0 0 auto;
    display: flex;
    flex-flow: row;
    cursor: pointer;
  }
  .date-select {
    font-size: 1em;
    height: 1.6em;
    padding: 0.2em;
    margin: 0.4em 0.4em 0.4em 0em; /* top | right | bottom | left */
  }
  select {
    font-size: 1em;
    height: 1.6em;
    padding: 0.2em;
    margin: 0.4em 0.4em 0.4em 0em; /* top | right | bottom | left */
  }
  .go {
    font-size: 1em;
    height: 1.6em;
    margin: 0.4em 0.4em 0.4em 0em; /* top | right | bottom | left */
    padding: 0 0.4em 0 0.4em; /* top | right | bottom | left */
  }
  p {
    font-size: 1em;
    margin: 0.2em 0.4em 0.2em 0.2em; /* top | right | bottom | left */
  }
  .red {
    background-color: #f009;
  }
  .blue {
    background-color: #00f9;
  }
  .violet {
    background-color: #a4a9;
  }
  .pink {
    background-color: #f909;
  }
  label {
    /*text-shadow: -1px -1px 0 #fff8, 1px -1px 0 #fff8, -1px 1px 0 #fff8, 1px 1px 0 #fff8;*/
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
    /*margin-top: 0.5em;
    /*margin-bottom: 0.5em;*/
    margin: 0 0 0 0.4em; /* top | right | bottom | left */
    padding: 0.2em 0 0 0; /* top | right | bottom | left */
    /*align-self: center;*/
  }
  .checkbox {
    box-shadow: none;
    min-width: 0em;
    cursor: pointer;
    padding: 0;
    margin: 0;
    align-self: center;
  }
/*  @media screen and (max-width: 800px) {
    .layers {
      margin-top: 3em;
    }
  }*/
</style>

<script>
  import station from '../station';
  import { onMount } from 'svelte';
  import maplibregl from 'maplibre-gl/dist/maplibre-gl.js';
  import 'maplibre-gl/dist/maplibre-gl.css';
  
  import { zonedTimeToUtc } from 'date-fns-tz';
  
  function get_date_str(day_str) {
    let date_utc = zonedTimeToUtc(`${day_str} 12:00`, 'Europe/Riga');
    let date_str = date_utc.toISOString().slice(0, 13).replace('T', '-');
    return date_str;
  }
  
  function get_dates() {
    let now = new Date();
    let today_str = now.toISOString().slice(0, 10);
    let dates = [];
    let add_date;
    let add_date_str = '2021-01-01'; //start date
    while (add_date_str < today_str) {
      dates.push(add_date_str);
      add_date = new Date(new Date(`${add_date_str} 12:00`).getTime() + 24 * 3600 * 1000)
      add_date_str = add_date.toISOString().slice(0, 10);
    }
    dates.sort();
    return dates;
  }
  
  function go_prev() {
    let go_index = dates.indexOf(date_selected) - 1;
    if (go_index >= 0) {
      date_selected = dates[go_index];
      update_map();
    }
  }
  
  function go_next() {
    let go_index = dates.indexOf(date_selected) + 1;
    if (go_index < dates.length) {
      date_selected = dates[go_index];
      update_map();
    }
  }
  
  function update_map(event, first_run) {
    var layers = map.getStyle().layers;
    // Find the index of the first symbol layer in the map style
    var firstSymbolId;
    for (var i = 0; i < layers.length; i++) {
      if (layers[i].type === 'symbol') {
        firstSymbolId = layers[i].id;
        break;
      }
    }
    if (first_run) {
      map.addSource('station', {
        'type': 'geojson',
        'data': station,
        'attribution': '<a href="https://videscentrs.lvgmc.lv/">LVĢMc</a>'
        });
      map.addSource('cadastre-wms', {
        'type': 'raster',
        'tiles': [
          'https://lvmgeoserver.lvm.lv/geoserver/ows?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.1.1&request=GetMap&srs=EPSG:3857&transparent=true&width=512&height=512&layers=publicwfs:Kadastra_karte'
        ],
        'tileSize': 512,
        'attribution': '<a href="https://www.lvmgeo.lv/dati">LVM GEO</a>, <a href="https://www.vzd.gov.lv/lv/kadastra-informacijas-sistemas-atvertie-dati">VZD</a>'
        });
      map.addSource('ortho-wms', {
        'type': 'raster',
        'tiles': [
          'https://lvmgeoserver.lvm.lv/geoserver/ows?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.1.1&request=GetMap&srs=EPSG:3857&transparent=true&width=512&height=512&layers=public:Orto_7cikls'
        ],
        'tileSize': 512,
        'attribution': '<a href="https://www.lvmgeo.lv/dati">LVM GEO</a>, <a href="https://www.lgia.gov.lv/lv/atvertie-dati">LĢIA</a>'
        });
      map.addSource('sat-basemap-xyz', {
        'type': 'raster',
        'tiles': [
          'https://api2.forestradar.com/layers/s2-rgb/latest/{z}/{x}/{y}.png'
        ],
        'tileSize': 256,
        'attribution': '<a href="https://www.baltsat.lv/">Baltic Satellite Service</a>, <a href="https://www.esa.int/">ESA</a>'
        });
      // map.addSource('sat-basemap-wms', {
      //   'type': 'raster',
      //   'tiles': [
      //     'https://wms.forestradar.com/wms-v1/dmo-9EDp-Q7Nutoz_Mn4QOtv_A/wms?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.1.1&request=GetMap&srs=EPSG:3857&transparent=true&width=512&height=512&layers=s2_metadata&service=WMS&styles='
      //   ],
      //   'tileSize': 512,
      //   'attribution': '<a href="https://www.baltsat.lv/">Baltic Satellite Service</a>, <a href="https://www.esa.int/">ESA</a>'
      //   });
      map.addSource('terrain-wms', {
        'type': 'raster',
        'tiles': [
          'https://lvmgeoserver.lvm.lv/geoserver/ows?bbox={bbox-epsg-3857}&format=image/png&service=WMS&version=1.1.1&request=GetMap&srs=EPSG:3857&transparent=true&width=512&height=512&layers=DTM_contours'
        ],
        'tileSize': 512,
        'attribution': '<a href="https://www.lvmgeo.lv/dati">LVM GEO</a>, <a href="https://www.lgia.gov.lv/lv/atvertie-dati">LĢIA</a>'
        });
      map.addSource('aoi-source', {
        'type': 'vector',
        'tiles': [
          `https://api2.forestradar.com/layers/flood/aoi/mvt/{z}/{x}/{y}.pbf`
        ],
        'maxzoom': 10,
      });
    }
    let prev_layer = null;
    if (has_station) {
      map.removeLayer('station-circle');
      map.removeLayer('station-text');
      has_station = false;
    }
    if (show_station) {
      map.addLayer(
        {
          'id': 'station-text',
          'type': 'symbol',
          'source': 'station',
          'paint': {
            'text-color': '#003399',
            'text-halo-blur': 0.3,
            'text-halo-color': 'rgba(255, 255, 255, 255)',
            'text-halo-width': 1.5,
          },
          'layout': {
            'text-field': ['get', 'st_name'],
            'text-radial-offset': 0.5,
            'text-size': 18,
            'text-variable-anchor': ['bottom'],
          },
        }
      );
      map.addLayer(
        {
          'id': 'station-circle',
          'type': 'circle',
          'source': 'station',
          'paint': {
            'circle-radius': 4,
            'circle-color': '#0066cc',
            'circle-stroke-color': '#ffffff',
            'circle-stroke-width': 1,
            'circle-stroke-opacity': 1,
          },
        },
        'station-text'
      );
      prev_layer = 'station-circle';
      has_station = true;
    }
    if (has_model) {
      map.removeLayer('model');
      map.removeSource('model-source');
      has_model = false;
    }
    if (show_model) {
      map.addSource('model-source', {
        'type': 'vector',
        'tiles': [
          `https://api2.forestradar.com/layers/flood/model/mvt/${get_date_str(date_selected)}/{z}/{x}/{y}.pbf`
        ],
        'maxzoom': 10,
      });
      map.addLayer(
        {
          'id': 'model',
          'type': 'fill',
          'source': 'model-source',
          'source-layer': 'data',
          'layout': {},
          'paint': {
            'fill-color': '#00f',
            'fill-opacity': 0.5,
          },
        },
        prev_layer
      );
      prev_layer = 'model';
      has_model = true;
    }
    if (has_model_pred) {
      map.removeLayer('model-pred');
      map.removeSource('model-pred-source');
      has_model_pred = false;
    }
    if (show_model_pred) {
      map.addSource('model-pred-source', {
        'type': 'vector',
        'tiles': [
          `https://api2.forestradar.com/layers/flood/model/mvt/${get_date_str(date_selected)}+${risk_level}/{z}/{x}/{y}.pbf`
        ],
        'maxzoom': 10,
      });
      map.addLayer(
        {
          'id': 'model-pred',
          'type': 'fill',
          'source': 'model-pred-source',
          'source-layer': 'data',
          'layout': {},
          'paint': {
            'fill-color': '#f90',
            'fill-opacity': 0.5,
          },
        },
        prev_layer
      );
      prev_layer = 'model-pred';
      has_model_pred = true;
    }
    if (has_sat) {
      map.removeLayer('s1-layer');
      map.removeSource('s1-source');
      map.removeLayer('s2-layer');
      map.removeSource('s2-source');
      has_sat = false;
    }
    if (show_sat) {
      map.addSource(
        's1-source',
        {
          'type': 'vector',
          'tiles': [
            `https://api2.forestradar.com/layers/flood/s1-v5/mvt/${date_selected}/{z}/{x}/{y}.pbf`
          ],
          'maxzoom': 10,
        }
      );
      map.addSource(
        's2-source',
        {
          'type': 'vector',
          'tiles': [
            `https://api2.forestradar.com/layers/flood/s2-v4/mvt/${date_selected}/{z}/{x}/{y}.pbf`
          ],
          'maxzoom': 10,
        }
      );
      map.addLayer(
        {
          'id': 's1-layer',
          'type': 'fill',
          'source': 's1-source',
          'source-layer': 'data',
          'layout': {},
          'paint': {
            'fill-color': '#f00',
            'fill-opacity': 0.5,
          },
        },
        prev_layer
      );
      map.addLayer(
        {
          'id': 's2-layer',
          'type': 'fill',
          'source': 's2-source',
          'source-layer': 'data',
          'layout': {},
          'paint': {
            'fill-color': '#f00',
            'fill-opacity': 0.5,
          },
        },
        's1-layer'
      );
      prev_layer = 's2-layer';
      has_sat = true;
    }
    if (has_aoi) {
      map.removeLayer('aoi');
      has_aoi = false;
    }
    if (show_aoi) {
      map.addLayer(
        {
          'id': 'aoi',
          'type': 'line',
          'source': 'aoi-source',
          'source-layer': 'latvia-flood-aoi',
          'layout': {},
          'paint': {
            'line-color': '#a4a',
            'line-opacity': 0.8,
            'line-width': 2.5,
            'line-dasharray': [3, 1, 1, 1],
          },
        },
        prev_layer
      );
      prev_layer = 'aoi';
      has_aoi = true;
    }
    if (has_cadastre) {
      map.removeLayer('cadastre');
      has_cadastre = false;
    }
    if (show_cadastre) {
      map.addLayer(
        {
          'id': 'cadastre',
          'type': 'raster',
          'source': 'cadastre-wms',
          'paint': {},
        },
        prev_layer
      );
      prev_layer = 'cadastre';
      has_cadastre = true;
    }
    if (has_ortho) {
      map.removeLayer('ortho');
      has_ortho = false;
    }
    if (show_ortho) {
      map.addLayer(
        {
          'id': 'ortho',
          'type': 'raster',
          'source': 'ortho-wms',
          'paint': {},
        },
        prev_layer
      );
      prev_layer = 'ortho';
      has_ortho = true;
    }
    if (has_sat_basemap) {
      // map.removeLayer('sat-basemap-metadata');
      map.removeLayer('sat-basemap-mosaic');
      has_sat_basemap = false;
    }
    if (show_sat_basemap) {
      // map.addLayer(
      //   {
      //     'id': 'sat-basemap-metadata',
      //     'type': 'raster',
      //     'source': 'sat-basemap-wms',
      //     'paint': {},
      //   },
      //   prev_layer
      // );
      map.addLayer(
        {
          'id': 'sat-basemap-mosaic',
          'type': 'raster',
          'source': 'sat-basemap-xyz',
          'paint': {},
        },
        prev_layer
        // 'sat-basemap-metadata'
      );
      prev_layer = 'sat-basemap-mosaic';
      has_sat_basemap = true;
    }
    if (has_terrain) {
      map.removeLayer('terrain');
      has_terrain = false;
    }
    if (show_terrain) {
      map.addLayer(
        {
          'id': 'terrain',
          'type': 'raster',
          'source': 'terrain-wms',
          'paint': {},
        },
        prev_layer
      );
      has_terrain = true;
    }
  }
  
  function toggle_layers_open() {
    if (layers_open) {
      layers_open = false;
    } else {
      layers_open = true;
    };
  }
  
  let dates = get_dates();
  let date_selected = dates[dates.length - 1];
  let map;
  let risk_level = '40';
  
  let has_aoi = false;
  let has_cadastre = false;
  let has_model = false;
  let has_model_pred = false;
  let has_ortho = false;
  let has_sat = false;
  let has_sat_basemap = false;
  let has_station = false;
  let has_terrain = false;
  
  let show_aoi = true;
  let show_cadastre = false;
  let show_model = true;
  let show_model_pred = true;
  let show_ortho = false;
  let show_sat = true;
  let show_sat_basemap = false;
  let show_station = true;
  let show_terrain = false;
  
  let layers_open = true;
  
  onMount(() => {
    map = new maplibregl.Map({
      container: 'map',
      style: 'https://api.maptiler.com/maps/streets/style.json?key=ZXgVBaZX5zOt2tnuxT2f',
      zoom: 6,
      center: [24, 57],
      hash: true,
      pitchWithRotate: false,
    });
    map.on('load', function () {
      update_map({}, true);
    });
  });
</script>

<main>
  <div class='settings'>
    <div class='layers'>
      <div class='caption' on:click={toggle_layers_open}>
        <p>Kartes slāņi</p>
        <div class='filler'></div>
        {#if layers_open}
          <p>↑</p>
        {:else}
          <p>↓</p>
        {/if}
      </div>
      {#if layers_open}
        <div class='layer'>
          <input type='checkbox' class='checkbox' id='station' bind:checked={show_station} on:change={update_map}>
          <label for='station' class='layer-text'>Monitoringa stacijas</label>
        </div>
        <div class='layer'>
          <input type='checkbox' class='checkbox' id='sat' bind:checked={show_sat} on:change={update_map}>
          <label for='sat' class='layer-text'>Faktiskais ūdens (satelīts)</label>
          <div class='legend red'></div>
        </div>
        <div class='layer'>
          <input type='checkbox' class='checkbox' id='model' bind:checked={show_model} on:change={update_map}>
          <label for='model' class='layer-text'>Modelētais ūdens (tagad)</label>
          <div class='legend blue'></div>
        </div>
        <div class='layer'>
          <input type='checkbox' class='checkbox' id='model-pred' bind:checked={show_model_pred} on:change={update_map}>
          <label for='model-pred' class='layer-text'>Modelētais ūdens (iesp. risks)</label>
          <div class='legend pink'></div>
        </div>
        <div class='layer'>
          <input type='checkbox' class='checkbox' id='aoi' bind:checked={show_aoi} on:change={update_map}>
          <label for='aoi' class='layer-text'>Monitoringa robeža</label>
          <div class='legend violet'></div>
        </div>
        <div class='layer'>
          <input type='checkbox' class='checkbox' id='cadastre' bind:checked={show_cadastre} on:change={update_map}>
          <label for='cadastre' class='layer-text'>Kadastrs</label>
        </div>
        <div class='layer'>
          <input type='checkbox' class='checkbox' id='ortho' bind:checked={show_ortho} on:change={update_map}>
          <label for='ortho' class='layer-text'>Ortofoto (2019-2021)</label>
        </div>
        <div class='layer'>
          <input type='checkbox' class='checkbox' id='sat-basemap' bind:checked={show_sat_basemap} on:change={update_map}>
          <label for='sat-basemap' class='layer-text'>Satelīts (jaunākais)</label>
        </div>
        <div class='layer'>
          <input type='checkbox' class='checkbox' id='terrain' bind:checked={show_terrain} on:change={update_map}>
          <label for='terrain' class='layer-text'>Reljefs</label>
        </div>
      {/if}
    </div>
    <div class='risk'>
      <p>Riska līmenis</p>
      <div class='filler'></div>
      <select bind:value={risk_level} on:change={update_map} required>
        <option value='20'>+0.20m</option>
        <option value='40'>+0.40m</option>
        <option value='60'>+0.60m</option>
        <option value='80'>+0.80m</option>
        <option value='100'>+1.00m</option>
      </select>
    </div>
    <div class='date'>
      <p>Datums</p>
      <div class='filler'></div>
      <button class='go' on:click={go_prev}>←</button>
      <input type="date" class="date-select" on:change={update_map} min={dates[0]} max={dates[dates.length-1]} required bind:value={date_selected}>
      <button class='go' on:click={go_next}>→</button>
    </div>
  </div>
  <div class='map' id='map'></div>
</main>
